import { Button, makeStyles, TableCell, TableRow } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { SwissGermanLocale } from "../../../../data/constants";
import { ModuleForSignupViewModel } from "../../../../model/ExamSignup/ExamSessionForSignupViewModel";
import {
  ModuleSelectionExamDetails,
  ModuleSelectionViewModel,
} from "../../../../model/ExamSignup/ModuleSelectionViewModel";
import { GetTranslatedValueIntl, TranslatedValue } from "../../../../model/Shared/TranslatedValue";
import TranslatedMessage from "../../../translations/TranslatedMessage";
import ModuleExamList from "./ModuleExamList";
import { useSignUpContext } from "../../CertificationDataWizardContext/CertificationDataWizardContext";

export type ModuleSelectorRowProps = {
  examSessionId: string;
  examSessionKey: TranslatedValue;
  courseId: string;
  courseName: TranslatedValue;
  module: ModuleForSignupViewModel;
  rowButtonAction: (module: ModuleSelectionViewModel) => void;
};

const useStyles = makeStyles({
  button: { textTransform: "none", whiteSpace: "nowrap" },
});

export const ModuleSelectorRow: React.FunctionComponent<ModuleSelectorRowProps> = ({
  examSessionId,
  courseId,
  module,
  rowButtonAction,
}) => {
  const intl = useIntl();
  const classes = useStyles();
   const {
      data: { candidate },
    } = useSignUpContext();

  return (
    <React.Fragment>
      <TableRow>
        <TableCell style={{ fontWeight: "bold" }}>{GetTranslatedValueIntl(intl, module.name)}</TableCell>
        <TableCell>
          <ModuleExamList exams={module.exams} />
        </TableCell>
        <TableCell align="right">
          {module.price.toLocaleString(SwissGermanLocale, { minimumFractionDigits: 2 })}
        </TableCell>
        <TableCell align="right">
          <Button
            onClick={() => {
              // Initialize exam details is necessary for exams of type Term Paper, as no selection is required for them.
              const examDetails = module.exams.map(
                (e) => ({ examId: e.id, examType: e.type, language: candidate.correspondenceLanguage } as ModuleSelectionExamDetails)
              );
              rowButtonAction({
                courseId,
                examSessionId,
                moduleId: module.id,
                examDetails,
                price: module.price,
              });
            }}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            <TranslatedMessage id="startCertification.moduleSelectionStep.selectButton" />
          </Button>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
